import { render, staticRenderFns } from "./BasicInfoView.vue?vue&type=template&id=0a64cc8a&"
import script from "./BasicInfoView.vue?vue&type=script&lang=js&"
export * from "./BasicInfoView.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports